'use client'

import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query'

import { listResearchThreads } from '@/service/research.api'

const THREAD_PAGE_SIZE = 20

export const researchKeys = {
  all: ['research'] as const,
  threads: () => [...researchKeys.all, 'threads'] as const,
  threadList: (q: string) => [...researchKeys.threads(), 'list', q] as const,
  thread: (threadId: string) => [...researchKeys.threads(), 'detail', threadId] as const,
}

/** The user's research threads, newest activity first, optionally filtered by title. */
export function useResearchThreads(q: string, enabled = true) {
  return useInfiniteQuery({
    queryKey: researchKeys.threadList(q),
    queryFn: ({ pageParam }) =>
      listResearchThreads({ limit: THREAD_PAGE_SIZE, cursor: pageParam, q }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor,
    enabled,
    staleTime: 30_000,
    // A new search keeps showing the previous results until its own arrive.
    placeholderData: keepPreviousData,
  })
}
